<template>
    <div class="p-0 pl-4 pr-4 shadow-sm">
        <div
            v-html="text"
            class="richText-title text-[#121212] font-Open text-base font-normal leading-6"></div>
    </div>
</template>

<script>
    export default {
        props: {
            text: String,
        },
    };
</script>
